import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import { AuthProvider } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import Login from './pages/Login';
import ProgramManagement from './pages/ProgramManagement';
import ProductManagement from './pages/ProductManagement';
import LicenseManagement from './pages/LicenseManagement';
import ChangePassword from './pages/ChangePassword';
import Shop from './pages/Shop';
import ShopSuccess from './pages/ShopSuccess';
import DiscordSettings from './pages/DiscordSettings';

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: (
          <ProtectedRoute>
            <div className="welcome-screen">
              <p className="welcome-title">Willkommen im License Manager</p>
              <p className="welcome-sub">Programme und Lizenzen über die Navigation verwalten.</p>
            </div>
          </ProtectedRoute>
        ),
      },
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "shop",
        element: <Shop />,
      },
      {
        path: "shop/success",
        element: <ShopSuccess />,
      },
      {
        path: "programs",
        element: (
          <ProtectedRoute>
            <ProgramManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "products",
        element: (
          <ProtectedRoute>
            <ProductManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "licenses",
        element: (
          <ProtectedRoute>
            <LicenseManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "change-password",
        element: (
          <ProtectedRoute>
            <ChangePassword />
          </ProtectedRoute>
        ),
      },
      {
        path: "discord",
        element: (
          <ProtectedRoute>
            <DiscordSettings />
          </ProtectedRoute>
        ),
      },
    ],
  },
], {
  basename: "/"
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
